module.exports = __webpack_public_path__ + "img/workspace-onboarding/custom-branding-4133926464bedf9916f82ce50ee57909.png";